import request from '@/utils/request'
const BASE_URL = '/RpPayDoc'

export default {
  getRpChkPayWriteOff(data) {
    return request({
      url: BASE_URL + '/GetRpChkPayWriteOff',
      method: 'post',
      data
    })
  },
  getRpPayWriteOff(data) {
    return request({
      url: BASE_URL + '/GetRpPayWriteOff',
      method: 'post',
      data
    })
  },
  getBankCheckInBalanceExport(data){
    return request({
      url: BASE_URL + '/GetBankCheckInBalanceExport',
      method: 'post',
      responseType: 'blob',
      data
    }).then(res => {

      var file = res.data;
      console.log('res', res, res.data)
      var disposition = res.headers['content-disposition'];
      // console.log('disposition', disposition);

      var fileName = "导出";
      if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
        var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
        fileName = decodeURI(text);
      }

      if (navigator.msSaveBlob) {
        // IE10+下载
        navigator.msSaveBlob(file, fileName);
      } else {
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.target = "_blank";
        elink.href = URL.createObjectURL(file);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      }
      return Promise.resolve();
    
    }).catch(err => {
      console.log(err)
    })
  },
  getRpChkPayWriteOffExport(data){
    return request({
      url: BASE_URL + '/GetRpChkPayWriteOffExport',
      method: 'post',
      responseType: 'blob',
      data
    }).then(res => {

      var file = res.data;
      console.log('res', res, res.data)
      var disposition = res.headers['content-disposition'];
      // console.log('disposition', disposition);

      var fileName = "导出";
      if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
        var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
        fileName = decodeURI(text);
      }

      if (navigator.msSaveBlob) {
        // IE10+下载
        navigator.msSaveBlob(file, fileName);
      } else {
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.target = "_blank";
        elink.href = URL.createObjectURL(file);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      }
      return Promise.resolve();
    
    }).catch(err => {
      console.log(err)
    })
  },
  getRpPayWriteOffExport(data){
    return request({
      url: BASE_URL + '/GetRpPayWriteOffExport',
      method: 'post',
      responseType: 'blob',
      data
    }).then(res => {

      var file = res.data;
      console.log('res', res, res.data)
      var disposition = res.headers['content-disposition'];
      // console.log('disposition', disposition);

      var fileName = "导出";
      if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
        var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
        fileName = decodeURI(text);
      }

      if (navigator.msSaveBlob) {
        // IE10+下载
        navigator.msSaveBlob(file, fileName);
      } else {
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.target = "_blank";
        elink.href = URL.createObjectURL(file);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      }
      return Promise.resolve();
    
    }).catch(err => {
      console.log(err)
    })
  }
}